export default "__VITE_ASSET__262f9c2c__"